window.onload = function() {
    //Homepage/F&B page show hero ticked list slider only when page has finished loading
    const tickedSlider = document.querySelector('.tickSlider');
    const spinner = document.querySelector('.spinner');
    
    if (tickedSlider) {
        tickedSlider.style.display = 'block';
    }
    
    if (spinner) {
        spinner.remove();
    }

    var faqs = document.getElementsByClassName("faq-item");
    var firstFaq = document.getElementById("faq0");
    
    if (firstFaq) {
        firstFaq.classList.add("active");
    }

    for (let i = 0; i < faqs.length; i++) {
        faqs[i].getElementsByClassName("faq-question")[0].addEventListener("click", function() {
            var clickedFaq = this.parentNode;
            if(clickedFaq.classList.contains("active")) {
                // If the clicked FAQ is already active, we'll just remove the active class (closing it)
                clickedFaq.classList.remove("active");
            } else {
                // If it's not already active, we'll find the currently active FAQ, close it, and open the clicked one
                var currentlyActive = document.querySelector(".faq-item.active");
                if (currentlyActive) {
                    currentlyActive.classList.remove("active");
                }
                clickedFaq.classList.add("active");
            }
        });
    };

    const floatingImage = document.querySelector('.f-icon');

    if (floatingImage) {
        setTimeout(function() {
            floatingImage.classList.remove('d-none');
            floatingImage.classList.add('floating-icon');
        }, 800);
    }
}
